import { css, type Theme } from "@emotion/react";
import { emerson } from "aviary-tokens/themes";

import { dimensions } from "@styles";

export const wellevateByFullscriptLogo = css`
  width: auto;
  height: 2.7rem;
  object-fit: contain;
`;

export const textAlign = css`
  text-align: center;
`;

export const boxContainer = css`
  display: flex;
  justify-content: center;
`;

export const box = (theme: Theme) => css`
  border: 1px solid ${theme.system.borderBase};
  // the max-width needs to be higher than desired so that 90% width can work for all screens
  max-width: 26rem;
  width: 90%;
`;

export const boxArrange = css`
  gap: 1.25rem;
`;

export const noDisplay = css`
  display: none;
`;

export const formStyle = css`
  gap: 1.25rem;
  display: flex;
  flex-direction: column;
`;

export const wellevateSignInButton = css`
  background-color: ${emerson.info.backgroundBase};

  &:hover {
    background-color: ${emerson.info.backgroundHover};
  }
`;

export const fsSignInText = css`
  @media (max-width: ${dimensions.phoneLarge}) {
    padding-left: 0.5rem;
  }
`;

export const fsLogo = css`
  width: 2.5rem;
  margin-left: 1rem;

  @media (max-width: ${dimensions.phoneLarge}) {
    display: none;
  }
`;

export const arrowIcon = css`
  margin: 0 1rem;

  @media (max-width: ${dimensions.phoneLarge}) {
    margin: 0 0.5rem;
  }
`;
